export const getFirstAssetUrl = (object: unknown): string | null => {
  if (object && Array.isArray(object)) {
    for (const entry of object) {
      const result = getFirstAssetUrl(entry);

      if (result !== null) {
        return result;
      }
    }
  } else if (object && typeof object === 'object') {
    if (
      'assetUrl' in object &&
      typeof object.assetUrl === 'string' &&
      (object.assetUrl.endsWith('.png') ||
        object.assetUrl.endsWith('.jpg') ||
        object.assetUrl.endsWith('.jpeg'))
    ) {
      return object.assetUrl as string;
    } else {
      for (const entry of Object.values(object)) {
        const result = getFirstAssetUrl(entry);

        if (result !== null) {
          return result;
        }
      }
    }
  }

  return null;
};
